import {
  STOCK_DETAIL_REQUESTING,
  STOCK_DETAIL_REQUEST_SUCCESS,
  STOCK_DETAIL_REQUEST_ERROR,
  STOCK_TRADE_REQUESTING,
  STOCK_TRADE_REQUEST_SUCCESS,
  STOCK_TRADE_REQUEST_ERROR,
  CST_REQUESTING,
  CST_REQUEST_SUCCESS,
  CST_REQUEST_ERROR,
  KQKD_REQUESTING,
  KQKD_REQUEST_SUCCESS,
  KQKD_REQUEST_ERROR,
  CDKT_REQUESTING,
  CDKT_REQUEST_SUCCESS,
  CDKT_REQUEST_ERROR,
  STOCK_HIS_REQUESTING,
  STOCK_HIS_REQUEST_SUCCESS,
  STOCK_HIS_REQUEST_ERROR,
  STOCK_NEWS_REQUESTING,
  STOCK_NEWS_REQUEST_SUCCESS,
  STOCK_NEWS_REQUEST_ERROR,
  STOCK_EVENTS_REQUESTING,
  STOCK_EVENTS_REQUEST_SUCCESS,
  STOCK_EVENTS_REQUEST_ERROR,
  NEWS_DETAIL_REQUESTING,
  NEWS_DETAIL_REQUEST_SUCCESS,
  NEWS_DETAIL_REQUEST_ERROR,
  STOCK_MANAGEMENT_REQUESTING,
  STOCK_MANAGEMENT_REQUEST_ERROR,
  STOCK_MANAGEMENT_REQUEST_SUCCESS,
  COMPANY_INFO_REQUESTING,
  COMPANY_INFO_REQUEST_SUCCESS,
  COMPANY_INFO_REQUEST_ERROR,
  ASSOCIATE_REQUESTING,
  ASSOCIATE_REQUEST_ERROR,
  ASSOCIATE_REQUEST_SUCCESS,
  TRANSFER_DATA_REQUESTING,
  TRANSFER_DATA_REQUEST_SUCCESS,
  TRANSFER_DATA_REQUEST_ERROR,
  COLLECTION_PRICE_REQUESTING,
  COLLECTION_PRICE_REQUEST_ERROR,
  COLLECTION_PRICE_REQUEST_SUCCESS,
} from './constants';

const initialState = {
  stockDetail: {},
  stockDetailRequesting: false,
  stockDetailSuccessful: false,
  stockDetailErrors: [],

  stockTrade: {},
  stockTradeRequesting: false,
  stockTradeSuccessful: false,
  stockTradeErrors: [],

  cst: {},
  cstRequesting: false,
  cstSuccessful: false,
  cstErrors: [],

  kqkd: {},
  kqkdRequesting: false,
  kqkdSuccessful: false,
  kqkdErrors: [],

  cdkt: {},
  cdktRequesting: false,
  cdktSuccessful: false,
  cdktErrors: [],

  stockHis: null,
  stockHisRequesting: false,
  stockHisSuccessful: false,
  stockHisErrors: [],

  stockNews: {},
  stockNewsRequesting: false,
  stockNewsSuccessful: false,
  stockNewsErrors: [],

  newsDetail: {},
  newsDetailRequesting: false,
  newsDetailSuccessful: false,
  newsDetailErrors: [],

  stockEvents: {},
  stockEventsRequesting: false,
  stockEventsSuccessful: false,
  stockEventsErrors: [],

  stockManage: {},
  stockManageRequesting: false,
  stockManageSuccessful: false,
  stockManageErrors: [],

  companyInfo: {},
  companyInfoRequesting: false,
  companyInfoSuccessful: false,
  companyInfoErrors: [],

  associate: [],
  transferData: [],

  collectionPrice: [],
};

const reducer = function widgetReducer(state = initialState, action) {
  switch (action.type) {
    case STOCK_DETAIL_REQUESTING:
      return {
        ...state,
        stockDetailRequesting: true,
        stockDetailSuccessful: false,
        stockDetailErrors: [],
      };

    case STOCK_DETAIL_REQUEST_SUCCESS:
      return {
        ...state,
        stockDetail: action.resData,
        stockDetailRequesting: false,
        stockDetailSuccessful: true,
        stockDetailErrors: [],
      };

    case STOCK_DETAIL_REQUEST_ERROR:
      return {
        ...state,
        stockDetailRequesting: false,
        stockDetailSuccessful: false,
        stockDetailErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case STOCK_TRADE_REQUESTING:
      return {
        ...state,
        stockTradeRequesting: true,
        stockTradeSuccessful: false,
        stockTradeErrors: [],
      };

    case STOCK_TRADE_REQUEST_SUCCESS:
      return {
        ...state,
        stockTrade: action.resData,
        stockTradeRequesting: false,
        stockTradeSuccessful: true,
        stockTradeErrors: [],
      };

    case STOCK_TRADE_REQUEST_ERROR:
      return {
        ...state,
        stockTradeRequesting: false,
        stockTradeSuccessful: false,
        stockTradeErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CST_REQUESTING:
      return {
        ...state,
        cstRequesting: true,
        cstSuccessful: false,
        cstErrors: [],
      };

    case CST_REQUEST_SUCCESS:
      return {
        ...state,
        cst: action.resData,
        cstRequesting: false,
        cstSuccessful: true,
        cstErrors: [],
      };

    case CST_REQUEST_ERROR:
      return {
        ...state,
        cstRequesting: false,
        cstSuccessful: false,
        cstErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case KQKD_REQUESTING:
      return {
        ...state,
        kqkdRequesting: true,
        kqkdSuccessful: false,
        kqkdErrors: [],
      };

    case KQKD_REQUEST_SUCCESS:
      return {
        ...state,
        kqkd: action.resData,
        kqkdRequesting: false,
        kqkdSuccessful: true,
        kqkdErrors: [],
      };

    case KQKD_REQUEST_ERROR:
      return {
        ...state,
        kqkdRequesting: false,
        kqkdSuccessful: false,
        kqkdErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CDKT_REQUESTING:
      return {
        ...state,
        cdktRequesting: true,
        cdktSuccessful: false,
        cdktErrors: [],
      };

    case CDKT_REQUEST_SUCCESS:
      return {
        ...state,
        cdkt: action.resData,
        cdktRequesting: false,
        cdktSuccessful: true,
        cdktErrors: [],
      };

    case CDKT_REQUEST_ERROR:
      return {
        ...state,
        cdktRequesting: false,
        cdktSuccessful: false,
        cdktErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case STOCK_HIS_REQUESTING:
      return {
        ...state,
        stockHis: null,
        stockHisRequesting: true,
        stockHisSuccessful: false,
        stockHisErrors: [],
      };

    case STOCK_HIS_REQUEST_SUCCESS:
      return {
        ...state,
        stockHis: action.resData,
        stockHisRequesting: false,
        stockHisSuccessful: true,
        stockHisErrors: [],
      };

    case STOCK_HIS_REQUEST_ERROR:
      return {
        ...state,
        stockHis: null,
        stockHisRequesting: false,
        stockHisSuccessful: false,
        stockHisErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case STOCK_NEWS_REQUESTING:
      return {
        ...state,
        stockNewsRequesting: true,
        stockNewsSuccessful: false,
        stockNewsErrors: [],
      };

    case STOCK_NEWS_REQUEST_SUCCESS:
      return {
        ...state,
        stockNews: action.resData,
        stockNewsRequesting: false,
        stockNewsSuccessful: true,
        stockNewsErrors: [],
      };

    case STOCK_NEWS_REQUEST_ERROR:
      return {
        ...state,
        stockNewsRequesting: false,
        stockNewsSuccessful: false,
        stockNewsErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case NEWS_DETAIL_REQUESTING:
      return {
        ...state,
        newsDetailRequesting: true,
        newsDetailSuccessful: false,
        newsDetailErrors: [],
      };

    case NEWS_DETAIL_REQUEST_SUCCESS:
      return {
        ...state,
        newsDetail: action.resData,
        newsDetailRequesting: false,
        newsDetailSuccessful: true,
        newsDetailErrors: [],
      };

    case NEWS_DETAIL_REQUEST_ERROR:
      return {
        ...state,
        newsDetailRequesting: false,
        newsDetailSuccessful: false,
        newsDetailErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case STOCK_EVENTS_REQUESTING:
      return {
        ...state,
        stockEventsRequesting: true,
        stockEventsSuccessful: false,
        stockEventsErrors: [],
      };

    case STOCK_EVENTS_REQUEST_SUCCESS:
      return {
        ...state,
        stockEvents: action.resData,
        stockEventsRequesting: false,
        stockEventsSuccessful: true,
        stockEventsErrors: [],
      };

    case STOCK_EVENTS_REQUEST_ERROR:
      return {
        ...state,
        stockEventsRequesting: false,
        stockEventsSuccessful: false,
        stockEventsErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case STOCK_MANAGEMENT_REQUESTING:
      return {
        ...state,
        stockManageRequesting: true,
        stockManageSuccessful: false,
        stockManageErrors: [],
      };

    case STOCK_MANAGEMENT_REQUEST_SUCCESS:
      return {
        ...state,
        stockManage: action.resData,
        stockManageRequesting: false,
        stockManageSuccessful: true,
        stockManageErrors: [],
      };

    case STOCK_MANAGEMENT_REQUEST_ERROR:
      return {
        ...state,
        stockManageRequesting: false,
        stockManageSuccessful: false,
        stockManageErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case COMPANY_INFO_REQUESTING:
      return {
        ...state,
        companyInfoRequesting: true,
        companyInfoSuccessful: false,
        companyInfoErrors: [],
      };

    case COMPANY_INFO_REQUEST_SUCCESS:
      return {
        ...state,
        companyInfo: action.resData,
        companyInfoRequesting: false,
        companyInfoSuccessful: true,
        companyInfoErrors: [],
      };

    case COMPANY_INFO_REQUEST_ERROR:
      return {
        ...state,
        companyInfoRequesting: false,
        companyInfoSuccessful: false,
        companyInfoErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case ASSOCIATE_REQUESTING:
    case ASSOCIATE_REQUEST_ERROR:
      return {
        ...state,
        associate: [],
      };
    case ASSOCIATE_REQUEST_SUCCESS:
      return {
        ...state,
        associate: action.resData,
      };

    case TRANSFER_DATA_REQUESTING:
    case TRANSFER_DATA_REQUEST_ERROR:
      return {
        ...state,
        transferData: [],
      };
    case TRANSFER_DATA_REQUEST_SUCCESS:
      return {
        ...state,
        transferData: action.resData,
      };

    case COLLECTION_PRICE_REQUESTING:
    case COLLECTION_PRICE_REQUEST_ERROR:
      return {
        ...state,
        collectionPrice: [],
      };
    case COLLECTION_PRICE_REQUEST_SUCCESS:
      return {
        ...state,
        collectionPrice: action.resData,
      };

    case 'CLEAR_CACHE_STOCK_DETAIL':
      return initialState;

    default:
      return state;
  }
};

export default reducer;
